import {
    IonAlert,
    IonBackButton,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCol,
    IonContent,
    IonGrid,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonLoading,
    IonModal,
    IonPage,
    IonRow,
    IonSelect,
    IonSelectOption,
    IonTitle,
    IonToast,
    IonToolbar,
    useIonViewDidEnter
} from '@ionic/react';
import {
    arrowBack,
    checkmarkCircleOutline,
    closeCircleOutline,
    cloudUploadOutline,
    refreshOutline,
    trashOutline,
    warningOutline
} from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import {
    fiscalBuscarConfiguracao,
    fiscalConsultarCertificado,
    fiscalRemoverCertificado,
    fiscalSalvarConfiguracao,
    fiscalStatusSefaz,
    fiscalUploadCertificado,
    requestService
} from '../../../../../Utils/Services';
import './FiscalConfiguracoes.css';

const UF_LIST = [
    { codigo: "11", nome: "RO" }, { codigo: "12", nome: "AC" }, { codigo: "13", nome: "AM" },
    { codigo: "14", nome: "RR" }, { codigo: "15", nome: "PA" }, { codigo: "16", nome: "AP" },
    { codigo: "17", nome: "TO" }, { codigo: "21", nome: "MA" }, { codigo: "22", nome: "PI" },
    { codigo: "23", nome: "CE" }, { codigo: "24", nome: "RN" }, { codigo: "25", nome: "PB" },
    { codigo: "26", nome: "PE" }, { codigo: "27", nome: "AL" }, { codigo: "28", nome: "SE" },
    { codigo: "29", nome: "BA" }, { codigo: "31", nome: "MG" }, { codigo: "32", nome: "ES" },
    { codigo: "33", nome: "RJ" }, { codigo: "35", nome: "SP" }, { codigo: "41", nome: "PR" },
    { codigo: "42", nome: "SC" }, { codigo: "43", nome: "RS" }, { codigo: "50", nome: "MS" },
    { codigo: "51", nome: "MT" }, { codigo: "52", nome: "GO" }, { codigo: "53", nome: "DF" },
];

type Props = {
    abrirMenu: boolean;
};

const FiscalConfiguracoes: React.FC<Props> = (props: Props) => {
    const history = useHistory();
    const { loja } = useContext(MessageContext);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    // Loading & Toasts
    const [showLoading, setShowLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Carregando...");
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [toastColor, setToastColor] = useState("success");

    // Certificado
    const [certInfo, setCertInfo] = useState<any>(null);
    const [showModalCertificado, setShowModalCertificado] = useState(false);
    const [showRemoverCertAlert, setShowRemoverCertAlert] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    // Upload modal states
    const [uploadBase64, setUploadBase64] = useState("");
    const [uploadNomeArquivo, setUploadNomeArquivo] = useState("");
    const [uploadSenha, setUploadSenha] = useState("");
    const [uploadLoading, setUploadLoading] = useState(false);
    const [uploadErro, setUploadErro] = useState("");

    // Configuração Fiscal
    const [uf, setUf] = useState("");
    const [csc, setCsc] = useState("");
    const [cscId, setCscId] = useState("1");
    const [ambiente, setAmbiente] = useState("2");
    const [cnpjEmitente, setCnpjEmitente] = useState("");
    const [serie, setSerie] = useState("1");
    const [serie1, setSerie1] = useState("0");
    const [serie2, setSerie2] = useState("0");
    const [serie3, setSerie3] = useState("0");
    const [configSalva, setConfigSalva] = useState(false);

    // Dados do Emitente
    const [razaoSocial, setRazaoSocial] = useState("");
    const [nomeFantasia, setNomeFantasia] = useState("");
    const [inscricaoEstadual, setInscricaoEstadual] = useState("");
    const [codigoMunicipio, setCodigoMunicipio] = useState("");
    const [regimeTributario, setRegimeTributario] = useState("1");
    const [telefone, setTelefone] = useState("");
    const [endLogradouro, setEndLogradouro] = useState("");
    const [endNumero, setEndNumero] = useState("");
    const [endComplemento, setEndComplemento] = useState("");
    const [endBairro, setEndBairro] = useState("");
    const [endMunicipio, setEndMunicipio] = useState("");
    const [endUf, setEndUf] = useState("");
    const [endCep, setEndCep] = useState("");

    // SEFAZ Status
    const [sefazStatus, setSefazStatus] = useState<string | null>(null);
    const [sefazChecking, setSefazChecking] = useState(false);

    const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));

    useIonViewDidEnter(() => {
        if (acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao') {
            history.replace('/empresa/home');
            return;
        }
        setEsconderMenu(true);
        setNomeMenu("");
        carregarCertificado();
        carregarConfiguracao();
    });

    // =============================
    // CERTIFICADO DIGITAL
    // =============================
    function carregarCertificado() {
        if (!loja) return;
        requestService(
            fiscalConsultarCertificado.url.replace("{empresaId}", loja.replaceAll(/#/g, '%23')),
            { method: fiscalConsultarCertificado.method, credentials: 'include' },
            history,
            (response: any) => {
                setCertInfo(response.dados || response);
            },
            (error: any) => {
                setCertInfo(null);
            }
        );
    }

    function handleSelecionarArquivo() {
        fileInputRef.current?.click();
    }

    function handleFileChange(event: any) {
        const file = event.target.files[0];
        if (!file) return;

        if (fileInputRef.current) fileInputRef.current.value = '';

        const reader = new FileReader();
        reader.onload = () => {
            const base64 = (reader.result as string).split(',')[1];
            setUploadBase64(base64);
            setUploadNomeArquivo(file.name);
            setUploadErro("");
        };
        reader.readAsDataURL(file);
    }

    function handleValidarESalvar() {
        if (!uploadBase64) {
            setUploadErro("Selecione o arquivo do certificado (.pfx ou .p12).");
            return;
        }
        if (!uploadSenha) {
            setUploadErro("Informe a senha do certificado.");
            return;
        }
        setUploadErro("");
        setUploadLoading(true);

        requestService(
            fiscalUploadCertificado.url,
            {
                method: fiscalUploadCertificado.method,
                body: JSON.stringify({
                    empresaId: loja,
                    certificadoBase64: uploadBase64,
                    senha: uploadSenha
                }),
                credentials: 'include'
            },
            history,
            (response: any) => {
                setUploadLoading(false);
                setShowModalCertificado(false);
                setUploadBase64("");
                setUploadNomeArquivo("");
                setUploadSenha("");
                mostrarToast("Certificado validado e salvo com sucesso!", "success");
                carregarCertificado();
            },
            (error: any) => {
                setUploadLoading(false);
                const msg = error.message || "Erro ao enviar certificado.";
                setUploadErro(msg);
            }
        );
    }

    function abrirModalCertificado() {
        setUploadBase64("");
        setUploadNomeArquivo("");
        setUploadSenha("");
        setUploadErro("");
        setShowModalCertificado(true);
    }

    function removerCertificado() {
        setShowLoading(true);
        setLoadingMessage("Removendo certificado...");

        requestService(
            fiscalRemoverCertificado.url.replace("{empresaId}", loja.replaceAll(/#/g, '%23')),
            { method: fiscalRemoverCertificado.method, credentials: 'include' },
            history,
            (response: any) => {
                setShowLoading(false);
                setCertInfo(null);
                mostrarToast("Certificado removido.", "success");
            },
            (error: any) => {
                setShowLoading(false);
                mostrarToast(error.message || "Erro ao remover certificado.", "danger");
            }
        );
    }

    function isCertExpirandoEm30Dias(): boolean {
        if (!certInfo?.validade) return false;
        const validade = new Date(certInfo.validade);
        const hoje = new Date();
        const diff = validade.getTime() - hoje.getTime();
        const dias = diff / (1000 * 60 * 60 * 24);
        return dias > 0 && dias <= 30;
    }

    function isCertExpirado(): boolean {
        if (!certInfo?.validade) return false;
        const validade = new Date(certInfo.validade);
        return validade.getTime() < new Date().getTime();
    }

    // =============================
    // CONFIGURAÇÃO FISCAL
    // =============================
    function carregarConfiguracao() {
        if (!loja) return;
        requestService(
            fiscalBuscarConfiguracao.url.replace("{empresaId}", loja.replaceAll(/#/g, '%23')),
            { method: fiscalBuscarConfiguracao.method, credentials: 'include' },
            history,
            (response: any) => {
                const dados = response.dados || response;
                if (dados.UF) setUf(dados.UF);
                if (dados.CSC) setCsc(dados.CSC);
                if (dados.CSCid) setCscId(dados.CSCid);
                if (dados.ambiente) setAmbiente(dados.ambiente);
                // CNPJ/CPF: carregado do banco (só números) → exibir com máscara
                if (dados.cnpjEmitente) setCnpjEmitente(aplicarMascaraCpfCnpj(dados.cnpjEmitente));
                if (dados.serie) setSerie(String(dados.serie));
                if (dados.serie1 !== undefined) setSerie1(String(dados.serie1));
                if (dados.serie2 !== undefined) setSerie2(String(dados.serie2));
                if (dados.serie3 !== undefined) setSerie3(String(dados.serie3));
                // Emitente
                if (dados.razaoSocial) setRazaoSocial(dados.razaoSocial);
                if (dados.nomeFantasia) setNomeFantasia(dados.nomeFantasia);
                if (dados.inscricaoEstadual) setInscricaoEstadual(dados.inscricaoEstadual);
                if (dados.codigoMunicipio) setCodigoMunicipio(dados.codigoMunicipio);
                if (dados.regimeTributario) setRegimeTributario(dados.regimeTributario);
                // Telefone: carregado sem máscara → exibir com máscara
                if (dados.telefone) setTelefone(aplicarMascaraTelefone(dados.telefone));
                if (dados.endereco) {
                    setEndLogradouro(dados.endereco.logradouro || "");
                    setEndNumero(dados.endereco.numero || "");
                    setEndComplemento(dados.endereco.complemento || "");
                    setEndBairro(dados.endereco.bairro || "");
                    setEndMunicipio(dados.endereco.municipio || "");
                    setEndUf(dados.endereco.uf || "");
                    // CEP: carregado sem máscara → exibir com máscara
                    if (dados.endereco.cep) setEndCep(aplicarMascaraCep(dados.endereco.cep));
                }
                setConfigSalva(true);
            },
            (error: any) => {
                console.log("Configuração fiscal não encontrada:", error);
            }
        );
    }

    function salvarConfiguracao() {
        // Validações de campos obrigatórios
        if (!uf) { mostrarToast("Selecione a UF.", "warning"); return; }
        if (!csc) { mostrarToast("Informe o CSC.", "warning"); return; }
        if (!cscId) { mostrarToast("Informe o ID do CSC.", "warning"); return; }
        if (!ambiente) { mostrarToast("Selecione o Ambiente.", "warning"); return; }
        const cnpjNums = removerMascara(cnpjEmitente);
        if (!cnpjNums || (cnpjNums.length !== 11 && cnpjNums.length !== 14)) { mostrarToast("Informe o CNPJ (14 dígitos) ou CPF (11 dígitos).", "warning"); return; }
        if (!serie) { mostrarToast("Informe a Série.", "warning"); return; }
        // Emitente
        if (!razaoSocial.trim()) { mostrarToast("Informe a Razão Social.", "warning"); return; }
        if (!inscricaoEstadual.trim()) { mostrarToast("Informe a Inscrição Estadual.", "warning"); return; }
        if (!codigoMunicipio.trim()) { mostrarToast("Informe o Código IBGE do Município.", "warning"); return; }
        if (!regimeTributario) { mostrarToast("Selecione o Regime Tributário.", "warning"); return; }
        // Endereço
        if (!endLogradouro.trim()) { mostrarToast("Informe o Logradouro.", "warning"); return; }
        if (!endNumero.trim()) { mostrarToast("Informe o Número do endereço.", "warning"); return; }
        if (!endBairro.trim()) { mostrarToast("Informe o Bairro.", "warning"); return; }
        if (!endMunicipio.trim()) { mostrarToast("Informe o Município.", "warning"); return; }
        if (!endUf) { mostrarToast("Selecione a UF do endereço.", "warning"); return; }
        const cepNums = removerMascara(endCep);
        if (!cepNums || cepNums.length !== 8) { mostrarToast("Informe o CEP (8 dígitos).", "warning"); return; }

        setShowLoading(true);
        setLoadingMessage("Salvando configuração...");

        requestService(
            fiscalSalvarConfiguracao.url,
            {
                method: fiscalSalvarConfiguracao.method,
                body: JSON.stringify({
                    empresaId: loja,
                    config: {
                        UF: uf,
                        CSC: csc,
                        CSCid: cscId,
                        ambiente: ambiente,
                        // Salvar CNPJ/CPF sem máscara (só números)
                        cnpjEmitente: cnpjNums,
                        serie: serie,
                        serie1: parseInt(serie1) || 0,
                        serie2: parseInt(serie2) || 0,
                        serie3: parseInt(serie3) || 0,
                        razaoSocial: razaoSocial,
                        nomeFantasia: nomeFantasia,
                        inscricaoEstadual: removerMascara(inscricaoEstadual),
                        codigoMunicipio: codigoMunicipio,
                        regimeTributario: regimeTributario,
                        // Salvar telefone sem máscara (só números)
                        telefone: removerMascara(telefone),
                        endereco: {
                            logradouro: endLogradouro,
                            numero: endNumero,
                            complemento: endComplemento,
                            bairro: endBairro,
                            municipio: endMunicipio,
                            uf: endUf,
                            // Salvar CEP sem máscara (só números)
                            cep: cepNums
                        }
                    }
                }),
                credentials: 'include'
            },
            history,
            (response: any) => {
                setShowLoading(false);
                setConfigSalva(true);
                mostrarToast("Configuração fiscal salva com sucesso!", "success");
            },
            (error: any) => {
                setShowLoading(false);
                mostrarToast(error.message || "Erro ao salvar configuração.", "danger");
            }
        );
    }

    // =============================
    // STATUS SEFAZ
    // =============================
    function consultarStatusSefaz() {
        setSefazChecking(true);
        setSefazStatus(null);

        requestService(
            fiscalStatusSefaz.url,
            {
                method: fiscalStatusSefaz.method,
                body: JSON.stringify({ empresaId: loja }),
                credentials: 'include',
                timeout: 30000
            },
            history,
            (response: any) => {
                setSefazChecking(false);
                const dados = response.dados || response;
                const cStat = dados.retConsStatServ?.cStat || dados.cStat || dados.status;
                setSefazStatus(cStat === "107" ? "online" : "offline");
            },
            (error: any) => {
                setSefazChecking(false);
                setSefazStatus("offline");
                mostrarToast(error.message || "Erro ao consultar SEFAZ.", "danger");
            }
        );
    }

    // =============================
    // MÁSCARAS
    // =============================
    function aplicarMascaraCpfCnpj(valor: string): string {
        const nums = valor.replace(/\D/g, '');
        if (nums.length <= 11) {
            return nums
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        }
        return nums.slice(0, 14)
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(.{3})\.(\d{3})(\d)/, '.$1.$2/$3')
            .replace(/(\d{4})(\d)/, '$1-$2');
    }

    function aplicarMascaraTelefone(valor: string): string {
        const nums = valor.replace(/\D/g, '').slice(0, 11);
        if (nums.length <= 10) {
            return nums
                .replace(/^(\d{2})(\d)/, '($1) $2')
                .replace(/(\d{4})(\d)/, '$1-$2');
        }
        return nums
            .replace(/^(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{5})(\d)/, '$1-$2');
    }

    function aplicarMascaraCep(valor: string): string {
        const nums = valor.replace(/\D/g, '').slice(0, 8);
        return nums.replace(/^(\d{5})(\d)/, '$1-$2');
    }

    function removerMascara(valor: string): string {
        return valor.replace(/\D/g, '');
    }

    function mostrarToast(msg: string, color: string) {
        setTextToast(msg);
        setToastColor(color);
        setShowToast(true);
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text='' />
                    </IonButtons>
                    <IonTitle slot="start">Configuração Fiscal</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="fiscal-config-container" color="light">

                {/* ========= CONFIGURAÇÃO FISCAL ========= */}
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle style={{ fontSize: "18px" }}>Configuração Fiscal</IonCardTitle>
                        <IonCardSubtitle>Dados para emissão de NFC-e na SEFAZ</IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent>
                        {/* Aviso de migração */}
                        {configSalva && (!razaoSocial || !endLogradouro) && (
                            <div className="fiscal-cert-status warning" style={{ marginBottom: "16px" }}>
                                <IonIcon icon={warningOutline} className="fiscal-cert-status-icon" color="warning" />
                                <div className="fiscal-cert-status-text">
                                    <p>Dados do emitente incompletos</p>
                                    <p>Preencha os campos de Razão Social e Endereço para garantir a emissão de NFC-e.</p>
                                </div>
                            </div>
                        )}
                        <IonList>
                            <IonItem>
                                <IonLabel position="stacked">UF *</IonLabel>
                                <IonSelect value={uf} placeholder="Selecione o estado" onIonChange={(e) => setUf(e.detail.value)}>
                                    {UF_LIST.map(estado => (
                                        <IonSelectOption key={estado.codigo} value={estado.codigo}>
                                            {estado.nome} ({estado.codigo})
                                        </IonSelectOption>
                                    ))}
                                </IonSelect>
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">CSC (Código de Segurança do Contribuinte) *</IonLabel>
                                <IonInput
                                    value={csc}
                                    placeholder="Informe o CSC obtido na SEFAZ"
                                    onIonChange={(e) => setCsc(e.detail.value || "")}
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">ID do CSC *</IonLabel>
                                <IonInput
                                    value={cscId}
                                    placeholder="Geralmente 1"
                                    onIonChange={(e) => setCscId(e.detail.value || "")}
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Ambiente *</IonLabel>
                                <IonSelect value={ambiente} onIonChange={(e) => setAmbiente(e.detail.value)}>
                                    <IonSelectOption value="2">Homologação (testes)</IonSelectOption>
                                    <IonSelectOption value="1">Produção</IonSelectOption>
                                </IonSelect>
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">CNPJ / CPF do Emitente *</IonLabel>
                                <IonInput
                                    value={cnpjEmitente}
                                    placeholder="00.000.000/0000-00 ou 000.000.000-00"
                                    onIonInput={(e: any) => {
                                        const masked = aplicarMascaraCpfCnpj(e.target.value || "");
                                        setCnpjEmitente(masked);
                                        e.target.value = masked;
                                    }}
                                    maxlength={18}
                                    inputmode="numeric"
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Série</IonLabel>
                                <IonInput
                                    value={serie}
                                    placeholder="Ex: 1"
                                    onIonChange={(e) => setSerie(e.detail.value || "1")}
                                    type="number"
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Último número emitido — Série 1</IonLabel>
                                <IonInput
                                    value={serie1}
                                    placeholder="Ex: 29 (0 para iniciar do começo)"
                                    onIonChange={(e) => setSerie1(e.detail.value || "0")}
                                    type="number"
                                    min="0"
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Último número emitido — Série 2</IonLabel>
                                <IonInput
                                    value={serie2}
                                    placeholder="Ex: 0"
                                    onIonChange={(e) => setSerie2(e.detail.value || "0")}
                                    type="number"
                                    min="0"
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Último número emitido — Série 3</IonLabel>
                                <IonInput
                                    value={serie3}
                                    placeholder="Ex: 0"
                                    onIonChange={(e) => setSerie3(e.detail.value || "0")}
                                    type="number"
                                    min="0"
                                />
                            </IonItem>
                        </IonList>
                    </IonCardContent>

                    <IonCardHeader>
                        <IonCardTitle style={{ fontSize: "18px" }}>Dados do Emitente</IonCardTitle>
                        <IonCardSubtitle>Informações da empresa emissora das notas</IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent>
                        <IonList>
                            <IonItem>
                                <IonLabel position="stacked">Razão Social *</IonLabel>
                                <IonInput
                                    value={razaoSocial}
                                    placeholder="Razão social da empresa"
                                    onIonChange={(e) => setRazaoSocial(e.detail.value || "")}
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Nome Fantasia</IonLabel>
                                <IonInput
                                    value={nomeFantasia}
                                    placeholder="Nome fantasia (opcional)"
                                    onIonChange={(e) => setNomeFantasia(e.detail.value || "")}
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Inscrição Estadual *</IonLabel>
                                <IonInput
                                    value={inscricaoEstadual}
                                    placeholder="Inscrição estadual"
                                    onIonChange={(e) => setInscricaoEstadual(e.detail.value || "")}
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Código IBGE do Município *</IonLabel>
                                <IonInput
                                    value={codigoMunicipio}
                                    placeholder="Ex: 3540309"
                                    onIonInput={(e: any) => {
                                        const apenasNumeros = (e.target.value || "").replace(/\D/g, "");
                                        setCodigoMunicipio(apenasNumeros);
                                        e.target.value = apenasNumeros;
                                    }}
                                    inputmode="numeric"
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Regime Tributário *</IonLabel>
                                <IonSelect value={regimeTributario} onIonChange={(e) => setRegimeTributario(e.detail.value)}>
                                    <IonSelectOption value="1">Simples Nacional</IonSelectOption>
                                    <IonSelectOption value="2">Simples Nacional – Excesso de Sublimite</IonSelectOption>
                                    <IonSelectOption value="3">Regime Normal</IonSelectOption>
                                </IonSelect>
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Telefone</IonLabel>
                                <IonInput
                                    value={telefone}
                                    placeholder="(00) 00000-0000"
                                    onIonInput={(e: any) => {
                                        const masked = aplicarMascaraTelefone(e.target.value || "");
                                        setTelefone(masked);
                                        e.target.value = masked;
                                    }}
                                    type="tel"
                                    maxlength={15}
                                    inputmode="numeric"
                                />
                            </IonItem>
                        </IonList>

                        <p style={{ fontSize: "13px", fontWeight: 600, color: "#555", margin: "16px 0 4px 4px" }}>Endereço</p>
                        <IonList>
                            <IonItem>
                                <IonLabel position="stacked">Logradouro *</IonLabel>
                                <IonInput value={endLogradouro} placeholder="Ex: Rua Amadeu Malvezzi" onIonChange={(e) => setEndLogradouro(e.detail.value || "")} />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Número *</IonLabel>
                                <IonInput value={endNumero} placeholder="Ex: 999" onIonChange={(e) => setEndNumero(e.detail.value || "")} />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Complemento</IonLabel>
                                <IonInput value={endComplemento} placeholder="Opcional" onIonChange={(e) => setEndComplemento(e.detail.value || "")} />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Bairro *</IonLabel>
                                <IonInput value={endBairro} placeholder="Ex: Centro" onIonChange={(e) => setEndBairro(e.detail.value || "")} />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">Município *</IonLabel>
                                <IonInput value={endMunicipio} placeholder="Ex: Potirendaba" onIonChange={(e) => setEndMunicipio(e.detail.value || "")} />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">UF *</IonLabel>
                                <IonSelect value={endUf} placeholder="Estado" onIonChange={(e) => setEndUf(e.detail.value)}>
                                    {UF_LIST.map(estado => (
                                        <IonSelectOption key={estado.codigo} value={estado.nome}>
                                            {estado.nome}
                                        </IonSelectOption>
                                    ))}
                                </IonSelect>
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">CEP *</IonLabel>
                                <IonInput
                                    value={endCep}
                                    placeholder="00000-000"
                                    onIonInput={(e: any) => {
                                        const masked = aplicarMascaraCep(e.target.value || "");
                                        setEndCep(masked);
                                        e.target.value = masked;
                                    }}
                                    maxlength={9}
                                    inputmode="numeric"
                                />
                            </IonItem>
                        </IonList>

                        <IonButton disabled={acessos?.configuracoes != 'edicao'} expand="block" style={{ marginTop: "16px" }} onClick={salvarConfiguracao}>
                            Salvar configuração
                        </IonButton>
                    </IonCardContent>
                </IonCard>

                {/* ========= CERTIFICADO DIGITAL ========= */}
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle style={{ fontSize: "18px" }}>
                            Certificado Digital A1
                        </IonCardTitle>
                        <IonCardSubtitle>Obrigatório para emissão de NFC-e</IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent>
                        {/* Estado 1: Sem certificado */}
                        {!certInfo && (
                            <>
                                <div className="fiscal-cert-status error">
                                    <IonIcon icon={closeCircleOutline} className="fiscal-cert-status-icon" color="danger" />
                                    <div className="fiscal-cert-status-text">
                                        <p>Certificado não configurado</p>
                                        <p>Envie seu certificado A1 (.pfx) para emitir notas</p>
                                    </div>
                                </div>
                                <IonButton disabled={acessos?.configuracoes != 'edicao'} expand="block" onClick={abrirModalCertificado}>
                                    <IonIcon slot="start" icon={cloudUploadOutline} />
                                    Enviar certificado
                                </IonButton>
                            </>
                        )}

                        {/* Estado 2: Certificado vencido */}
                        {certInfo && isCertExpirado() && (
                            <>
                                <div className="fiscal-cert-status error">
                                    <IonIcon icon={closeCircleOutline} className="fiscal-cert-status-icon" color="danger" />
                                    <div className="fiscal-cert-status-text">
                                        <p>Certificado vencido</p>
                                        {certInfo.validade && <p>Venceu em: {new Date(certInfo.validade).toLocaleDateString('pt-BR')}</p>}
                                        {certInfo.cnpj && <p>CNPJ: {certInfo.cnpj}</p>}
                                    </div>
                                </div>
                                <IonGrid>
                                    <IonRow>
                                        <IonCol>
                                            <IonButton disabled={acessos?.configuracoes != 'edicao'} expand="block" onClick={abrirModalCertificado}>
                                                <IonIcon slot="start" icon={cloudUploadOutline} />
                                                Substituir
                                            </IonButton>
                                        </IonCol>
                                        <IonCol>
                                            <IonButton disabled={acessos?.configuracoes != 'edicao'} expand="block" fill="outline" color="danger" onClick={() => setShowRemoverCertAlert(true)}>
                                                <IonIcon slot="start" icon={trashOutline} />
                                                Remover
                                            </IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </>
                        )}

                        {/* Estado 3: Certificado ativo */}
                        {certInfo && !isCertExpirado() && (
                            <>
                                <div className={`fiscal-cert-status ${isCertExpirandoEm30Dias() ? "warning" : "ok"}`}>
                                    <IonIcon
                                        icon={isCertExpirandoEm30Dias() ? warningOutline : checkmarkCircleOutline}
                                        className="fiscal-cert-status-icon"
                                        color={isCertExpirandoEm30Dias() ? "warning" : "success"}
                                    />
                                    <div className="fiscal-cert-status-text">
                                        <p>{isCertExpirandoEm30Dias() ? "Certificado próximo de expirar" : "Certificado ativo"}</p>
                                        {certInfo.cnpj && <p>CNPJ: {certInfo.cnpj}</p>}
                                        {certInfo.validade && <p>Validade: {new Date(certInfo.validade).toLocaleDateString('pt-BR')}</p>}
                                    </div>
                                </div>
                                <IonGrid>
                                    <IonRow>
                                        <IonCol>
                                            <IonButton disabled={acessos?.configuracoes != 'edicao'} expand="block" fill="outline" onClick={abrirModalCertificado}>
                                                <IonIcon slot="start" icon={refreshOutline} />
                                                Substituir
                                            </IonButton>
                                        </IonCol>
                                        <IonCol>
                                            <IonButton disabled={acessos?.configuracoes != 'edicao'} expand="block" fill="outline" color="danger" onClick={() => setShowRemoverCertAlert(true)}>
                                                <IonIcon slot="start" icon={trashOutline} />
                                                Remover
                                            </IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </>
                        )}
                    </IonCardContent>
                </IonCard>

                {/* ========= STATUS SEFAZ ========= */}
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle style={{ fontSize: "18px" }}>Status da SEFAZ</IonCardTitle>
                        <IonCardSubtitle>Verifique a conexão com a SEFAZ</IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent>
                        {sefazStatus && (
                            <div style={{ marginBottom: "12px" }}>
                                <span className={`fiscal-sefaz-badge ${sefazStatus}`}>
                                    <IonIcon icon={sefazStatus === "online" ? checkmarkCircleOutline : closeCircleOutline} />
                                    {sefazStatus === "online" ? "SEFAZ Online" : "SEFAZ Indisponível"}
                                </span>
                            </div>
                        )}
                        {(!configSalva || !certInfo || isCertExpirado()) && (
                            <div className="fiscal-info-box" style={{ marginBottom: "12px" }}>
                                <p style={{ margin: 0, fontSize: "13px" }}>
                                    {!configSalva && "Salve a configuração fiscal antes de testar. "}
                                    {configSalva && (!certInfo || isCertExpirado()) && "É necessário um certificado ativo para testar a conexão."}
                                </p>
                            </div>
                        )}
                        <IonButton
                            expand="block"
                            fill="outline"
                            onClick={consultarStatusSefaz}
                            disabled={sefazChecking || !configSalva || !certInfo || isCertExpirado()}
                        >
                            <IonIcon slot="start" icon={refreshOutline} />
                            {sefazChecking ? "Verificando..." : "Testar conexão com SEFAZ"}
                        </IonButton>
                    </IonCardContent>
                </IonCard>

                {/* ========= MODAL CERTIFICADO ========= */}
                <IonModal isOpen={showModalCertificado} onDidDismiss={() => setShowModalCertificado(false)}>
                    <IonHeader>
                        <IonToolbar color="primary">
                            <IonButtons slot="start" onClick={() => setShowModalCertificado(false)}>
                                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
                            </IonButtons>
                            <IonTitle>Enviar Certificado A1</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent color="light" style={{ '--padding-top': '16px', '--padding-bottom': '16px', '--padding-start': '16px', '--padding-end': '16px' }}>

                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".pfx,.p12"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                        {/* Área de seleção de arquivo */}
                        <div
                            className={`fiscal-upload-area${uploadNomeArquivo ? " selecionado" : ""}`}
                            onClick={handleSelecionarArquivo}
                            style={{ marginBottom: "16px" }}
                        >
                            <IonIcon icon={cloudUploadOutline} style={{ fontSize: "36px", color: uploadNomeArquivo ? "#2dd36f" : "#3880ff" }} />
                            {uploadNomeArquivo ? (
                                <>
                                    <p style={{ fontWeight: 600, color: "#2dd36f" }}>{uploadNomeArquivo}</p>
                                    <p style={{ color: "#888", fontSize: "12px" }}>Clique para trocar o arquivo</p>
                                </>
                            ) : (
                                <p>Clique para selecionar o arquivo .pfx ou .p12</p>
                            )}
                        </div>

                        {/* Campo senha */}
                        <IonList>
                            <IonItem>
                                <IonLabel position="stacked">Senha do certificado *</IonLabel>
                                <IonInput
                                    type="password"
                                    value={uploadSenha}
                                    placeholder="Senha do arquivo .pfx"
                                    onIonChange={(e) => { setUploadSenha(e.detail.value || ""); setUploadErro(""); }}
                                />
                            </IonItem>
                        </IonList>

                        {/* Mensagem de erro inline */}
                        {uploadErro && (
                            <div className="fiscal-cert-status error" style={{ margin: "12px 0" }}>
                                <IonIcon icon={closeCircleOutline} className="fiscal-cert-status-icon" color="danger" />
                                <div className="fiscal-cert-status-text">
                                    <p>{uploadErro}</p>
                                </div>
                            </div>
                        )}

                        <IonButton
                            expand="block"
                            style={{ marginTop: "24px" }}
                            onClick={handleValidarESalvar}
                            disabled={uploadLoading}
                        >
                            {uploadLoading ? "Validando..." : "Validar e salvar"}
                        </IonButton>

                        <IonLoading isOpen={uploadLoading} message="Validando certificado..." />
                    </IonContent>
                </IonModal>

                {/* ========= ALERTS ========= */}
                <IonAlert
                    isOpen={showRemoverCertAlert}
                    onDidDismiss={() => setShowRemoverCertAlert(false)}
                    header="Remover certificado"
                    message="Tem certeza? Sem certificado não será possível emitir NFC-e."
                    buttons={[
                        { text: 'Cancelar', role: 'cancel' },
                        { text: 'Remover', cssClass: 'primary', handler: () => removerCertificado() }
                    ]}
                />

                <IonLoading isOpen={showLoading} message={loadingMessage} />

                <IonToast
                    isOpen={showToast}
                    position="top"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                    color={toastColor}
                />
            </IonContent>
        </IonPage>
    );
};

export default FiscalConfiguracoes;
